import { ChangeCircle } from '@mui/icons-material'
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos'
import axios from 'axios';
import md5 from 'md5';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSoglia, setTaglia } from '../../features/userSlice';

function TagliaSogliaBox({currentPlan}) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const customerId = useSelector((user) => user.user.info.customer_id)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const taglia = useSelector((user) => user.user.importo_taglia)
    const soglia = useSelector((user) => user.user.importo_soglia)
    

    useEffect(() => {
        init()
    },[])

    const init = async () => {
        const url = `https://my.revoluce.it/area_utente/gestione/api/customers/getSogliaTaglia.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(url)
        const result = data.data[0]
        dispatch(setTaglia(result.importo_taglia))
        dispatch(setSoglia(result.soglia_incasso))
    }

    return (
        <>
           {currentPlan === 1 ? (
               <div className="tesBox tesBoxp">
                    <div className="soglia">
                        <p className="label">La tua soglia</p>
                        <span className="number">{soglia && soglia} <span className="currency">€</span></span>
                    </div>
                    <div className="taglia">
                        <p className="label">La tua taglia</p>
                        <span className="number">{taglia && taglia} <span className="currency">€</span></span>
                    </div>
                    <div className="discoverPlans" onClick={() => navigate('/enrica/fai-da-te/soglia-taglia')}>
                        <ChangeCircle className='changeIcon'/>
                        <p>Modifica taglia o soglia</p>
                        <ArrowForwardIos className='arrow'/>
                    </div>
                </div>
           ) : null} 
        </>
    )
}

export default TagliaSogliaBox
